import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { DialogProps } from '@material-ui/core/Dialog';
import { Form, Formik, FormikActions, FormikProps } from 'formik';
import * as React from 'react';
import Button from '../Button';

export interface IESDialog<T> extends DialogProps {
    close: () => void;
    children: (props: FormikProps<T>) => React.ReactNode;
    initialValues: T;
    isLoading?: boolean;
    title: string;
    save: (values: T, formikActions: FormikActions<T>) => void;
    saveButtonText?: string;
    validationSchema?: any;
    additionalButtons?: JSX.Element[];
    validateOnChange?: boolean;
    validateOnBlur?: boolean;
}

export default class ESDialog<T> extends React.Component<IESDialog<T>> {
    public render() {
        const {
            close,
            initialValues,
            isLoading,
            save,
            saveButtonText,
            title,
            validationSchema,
            additionalButtons,
            validateOnChange = true,
            validateOnBlur = true,
            ...rest
        } = this.props;

        return (
            <Dialog fullWidth={true} maxWidth="lg" onClose={close} {...rest}>
                <Formik
                    initialValues={initialValues}
                    onSubmit={save}
                    validationSchema={validationSchema}
                    validateOnChange={validateOnChange}
                    validateOnBlur={validateOnBlur}
                >
                    {(formikProps: FormikProps<T>) => (
                        <Form>
                            <DialogTitle>{title}</DialogTitle>
                            <DialogContent>{this.props.children(formikProps)}</DialogContent>
                            <DialogActions>
                                <Button onClick={close} data-cy="close">
                                    Close
                                </Button>
                                {additionalButtons}
                                <Button
                                    disabled={!formikProps.isValid || isLoading}
                                    isLoading={
                                        isLoading ||
                                        formikProps.isValidating ||
                                        formikProps.isSubmitting
                                    }
                                    color="primary"
                                    type="submit"
                                    variant="contained"
                                >
                                    {saveButtonText ? saveButtonText : 'Save'}
                                </Button>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </Dialog>
        );
    }
}



// WEBPACK FOOTER //
// ./src/common/ESDialog/ESDialog.tsx